import { GetEuclideanDistance } from "./types";

export const getEuclideanDistance: GetEuclideanDistance = ({
  pointA,
  pointB,
}) => {
  return Math.hypot(pointB.x - pointA.x, pointB.y - pointA.y);
};
